import pako from "pako";

/**
 * 压缩代码
 */
export function compress(code) {
  const compressedData = pako.deflate(code, {level: 9});
  return btoa(String.fromCharCode.apply(null, compressedData));
}

export const EncodeTypeEnum = {
  BASE64: 'BASE64',
  PAKO: 'PAKO'
};
export function encryptData(data, encodeType = EncodeTypeEnum.BASE64) {
  if (encodeType === EncodeTypeEnum.BASE64) {
    return dataTobase64(data);
  } else if (encodeType === EncodeTypeEnum.PAKO) {
    return compress(data);
  }
}

/**
 * 将数据转为base64
 * @param data
 * @returns null 转换失败   string 转化后的数据
 */
export function dataTobase64(data) {
  try {
    const strData = typeof data !== 'string' ? JSON.stringify(data) : data;
    return textToBase64(strData);
  } catch (error) {
    return null;
  }
}
export const textToBase64 = (text) => {
  const encoder = new TextEncoder();
  const uint8Array = encoder.encode(text);
  const binary = String.fromCharCode(...uint8Array);
  return btoa(binary);
}
